var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5206_3110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 23.7801C18.9064 23.7801 24.0999 18.5866 24.0999 12.1801C24.0999 5.77357 18.9064 0.580078 12.4999 0.580078C6.0934 0.580078 0.899902 5.77357 0.899902 12.1801C0.899902 18.5866 6.0934 23.7801 12.4999 23.7801Z",
    fill: "#6BB577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1002 18.58C9.783 18.58 9.4774 18.4544 9.2518 18.2284L6.0518 15.0284C5.583 14.56 5.583 13.8 6.0518 13.3316C6.5202 12.8628 7.2802 12.8628 7.7486 13.3316L9.9702 15.5532L16.3398 7.06002C16.7382 6.52962 17.491 6.42282 18.0198 6.82002C18.5502 7.21762 18.6578 7.97002 18.2602 8.50002L11.0602 18.1C10.8518 18.3784 10.5322 18.5524 10.1854 18.5768C10.157 18.5788 10.1282 18.58 10.1002 18.58Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5206_3110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.179688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRight);
export default __webpack_public_path__ + "static/media/green-right.489a4c945814a04b72b5368967777806.svg";
export { ForwardRef as ReactComponent };